import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { AddButton } from "../../../../components/Button";
import CommonDataGrid from "../../../../components/CommonDataGrid";
import { Column } from "../../../../components/CommonDataGrid/props";
import CustomDropdown from "../../../../components/DropDown";
import Loader from "../../../../components/Loader";
import DeleteImg from "../../../../images/SideBar/Delete";
import EditImg from "../../../../images/SideBar/Edit";
import ViewImg from "../../../../images/SideBar/View";
import {
  formatDate,
  formatTime,
  months,
  styles,
} from "../../../../util/constant";
import useLeave from "../useLeave";
import EditLeaveRequest from "./EditLeaveRequest/EditLeaveRequest";
import LeaveBalance from "./LeaveBalance";
import ViewLeaveIndex from "./ViewLeave";
import Modal from "../../../../components/Model";

const Leave: React.FC = () => {
  const {
    selectedLeaveId,
    selectedLeaveView,
    leaveData,
    showConfirmation,
    handleCancelStatusUp,
    updateScreen,
    handleConfirmStatusUp,
    handleEdit,
    setSearch,
    setPage,
    page,
    loading,
    totalPage,
    years,
    selectedYear,
    setSelectedYear,
    selectedMonth,
    setSelectedMonth,
    userLeave: leaveBalance,
  } = useLeave();

  const navigate = useNavigate();
  const [isLeavePolicyModalOpen, setIsLeavePolicyModalOpen] = useState(false);

  const openModal = () => setIsLeavePolicyModalOpen(true);
  const closeModal = () => setIsLeavePolicyModalOpen(false);

  const columns: Column[] = [
    {
      field: "type",
      headerName: "Leave Type",
      width: 50,
      align: "center",
    },
    {
      field: "subtype",
      headerName: "Sub Type",
      width: 50,
      align: "center",
    },
    {
      field: "description",
      headerName: "Description",
      width: 50,
      align: "center",
    },
    {
      field: "paidDays",
      headerName: "paid Days",
      width: 50,
      align: "center",
    },
    {
      field: "unpaidDays",
      headerName: "unpaid Days",
      width: 50,
      align: "center",
    },
    {
      field: "totalDays",
      headerName: "Total Days",
      width: 50,
      align: "center",
    },
    {
      field: "fromDate",
      renderCell: (params: any) => <p>{formatDate(params.value)}</p>,
      headerName: "From",
      align: "center",
      width: 50,
    },
    {
      field: "toDate",
      renderCell: (params: any) => <p>{formatDate(params.value)}</p>,
      headerName: "To",
      align: "center",
      width: 50,
    },
    {
      field: "createdAt",
      renderCell: (params: any) => <p>{formatDate(params.value)}</p>,
      headerName: "Requested At",
      align: "center",
      width: 50,
    },
    {
      field: "createdAt",
      renderCell: (params: any) => <p>{formatTime(params.value)}</p>,
      headerName: "Requested Time",
      align: "center",
      width: 50,
    },
    {
      field: "status",
      renderCell: (params: any) => (
        <p className={`${styles[params.value]}`}>{params.value}</p>
      ),
      headerName: "Status",
      width: 50,
      align: "center",
    },
    {
      field: "Actions",
      headerName: "Actions",
      width: 50,
      align: "center",
      renderCell: (params: any) => (
        <div className="flex space-x-2 justify-center">
          <button
            onClick={() => handleEdit(params.row._id)}
            className="text-fontColor hover:text-primary-2"
          >
            <EditImg />
          </button>
          {/* <button
            onClick={() => handleStatusUp(params.row._id)}
            className="text-red-500 hover:text-red-700"
          >
            <DeleteImg />
          </button>
          <button
            onClick={() => handleView(params.row)}
            className="text-gray-500 hover:text-gray-700"
          >
            <ViewImg />
          </button> */}
        </div>
      ),
    },
  ];
  console.log(leaveBalance, "leaveBalance");
  return (
    <div>
      <div className="m-5 h-[80vh] overflow-y-auto">
        {loading && <Loader />}
        <div>
          {selectedLeaveView ? (
            <ViewLeaveIndex
              leaveId={selectedLeaveView}
              setMethod={() => updateScreen("view")}
            />
          ) : selectedLeaveId ? (
            <EditLeaveRequest
              leaveId={selectedLeaveId}
              setMethod={() => updateScreen("edit")}
            />
          ) : (
            <>
              <div className="flex w-full justify-between">
                <div className="bg-transparent backdrop-blur-md  overflow-auto z-50 h-38 bg-yellow-200 px-4 w-[30vw]">
                  <h2 className="font-bold">Leave Rules:</h2>
                  <ul className="list-decimal pl-5 space-y-1 text-sm text-gray-800 font-semibold">
                    <li>1-day leave → Inform at least 3 days in advance.</li>
                    <li>
                      2 or 3 days of leave → Inform at least 2 weeks in advance.
                    </li>
                    <li>
                      3+ days of leave → Inform at least 30 days in advance.
                    </li>
                    <li>Sick leave → Inform TL/HR 2–3 hours before.</li>
                    <li>
                      For sick leave more than 2 days, provide a doctor’s
                      letter.
                    </li>
                    <li>
                      Leave without approval{" "}
                      <button
                        onClick={openModal}
                        className="text-blue-500 font-medium hover:underline ml-1"
                      >
                        view more...
                      </button>
                    </li>
                  </ul>
                </div>

                <LeaveBalance
                  remainingPaidLeave={leaveBalance?.remainingPaidLeave}
                  totalPaidLeave={leaveBalance?.totalPaidLeave}
                  totalTakenLeave={leaveBalance?.totalTakenLeave}
                  totalUnPaidLeave={leaveBalance?.totalUnPaidLeave}
                />
              </div>
              <div className="flex justify-between items-center m-4">
                <div className="flex items-center w-96 space-x-4">
                  <CustomDropdown
                    label="Year"
                    options={years.map((year) => ({
                      id: year,
                      value: year,
                      label: year.replace("-", " - "),
                    }))}
                    defaultOptionId={selectedYear}
                    setDefaultOptionId={setSelectedYear}
                    displayProperty="label"
                    value={selectedYear}
                    style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor"
                  />
                  <CustomDropdown
                    label="Month"
                    options={months.map((month: any) => ({
                      id: month.value,
                      ...month,
                    }))}
                    defaultOptionId={selectedMonth}
                    setDefaultOptionId={setSelectedMonth}
                    displayProperty="label"
                    value={selectedMonth}
                    style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor"
                  />
                </div>

                <div className="grid justify-items-end">
                  <AddButton
                    onClick={() => navigate("/add-leave-request")}
                    className=""
                    children="+"
                    type="button"
                  />
                </div>
              </div>

              <CommonDataGrid
                tableName="Leave"
                rows={leaveData}
                columns={columns}
                getRowId={(row) => row._id}
                showConfirmation={showConfirmation}
                confirmationMessage="Are you sure you want to Status Update this Leave?"
                onCancelDelete={handleCancelStatusUp}
                onConfirmDelete={handleConfirmStatusUp}
                loading={!leaveData}
                setSearchBar={setSearch}
                setCurrentPage={setPage}
                currentPage={page}
                totalPages={totalPage}
                dayFilter={false}
                searchFilter={false}
                downloadCSVFilter={false}
              />
            </>
          )}

          <Modal
            isOpen={isLeavePolicyModalOpen}
            onClose={closeModal}
            style="w-full max-w-4xl max-h-[90vh] overflow-y-auto mx-4"
          >
            <div className="p-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                Leave Policy
              </h3>

              <ul className="list-decimal pl-5 space-y-3 text-gray-700 text-sm">
                <li>1-day leave → Inform at least 3 days in advance.</li>
                <li>
                  2 or 3 days of leave → Inform at least 2 weeks in advance.
                </li>
                <li>3+ days of leave → Inform at least 30 days in advance.</li>
                <li>Sick leave → Inform TL/HR 2–3 hours before.</li>
                <li>
                  For sick leave of more than 2 days, a doctor’s letter is
                  mandatory.
                </li>

                <li>
                  <strong>Leave without Prior Approval:</strong>
                  <p className="mt-1">
                    Leave taken without prior approval on weekends or holidays
                    will result in salary deduction, even if leave balance
                    exists.
                  </p>
                </li>

                <li>
                  <strong>Weekend Leave (Friday & Monday):</strong>
                  <p className="mt-1">
                    If leave is taken on both Friday and Monday, 3 days will be
                    deducted.
                  </p>
                </li>

                <li>
                  <strong>Holiday Leave:</strong>
                  <p className="mt-1">
                    Deduction depends on the number of consecutive days taken.
                  </p>
                </li>

                <li>
                  <strong>Emergency Leave:</strong>
                  <p className="mt-1">
                    1 emergency leave is allowed per month. Additional leaves
                    will be considered unpaid based on the situation.
                  </p>
                </li>

                <li>
                  If Friday and Monday leaves are taken together, it will be
                  considered as 3 leaves.
                </li>
              </ul>
            </div>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default Leave;
